module.exports = __webpack_public_path__ + "img/quote.1b27f3be.png";